<script setup>
    import { ref, computed, defineEmits, defineExpose } from "vue";
    const props = defineProps({
        modelValue: { type: String },
        label: {
            type: String,
            default: '핸드폰 번호',
        },
        placeholder: {
            type: String,
            default: "'-' 입력 제외",
        },
        msg: {
            type: String,
            default: '',
        },
        msgColor: {
            type: String,
            default: '#ff0000'
        },
        disabled: {
            type: Boolean,
            default: false
        },
    });
    const emit = defineEmits(["update:modelValue"]);
    const model = computed({
        get() {
            return props.modelValue;
        },
        set(value) {
            emit("update:modelValue", value);
        },
    });

    const inputRef = ref(null)

    const getPhoneMask = () => {
        let res = getMask()
        // console.log(res);
        emit("update:modelValue", res);
    }

    const getMask = ( ) => {
        let str = props.modelValue
        str = str.replace(/[^0-9]/g, '');
        var tmp = '';
        if( str.length < 4){
            return str;
        }else if(str.length < 7){
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3);
            return tmp;
        }else if(str.length < 11){
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3, 3);
            tmp += '-';
            tmp += str.substr(6);
            return tmp;
        }else{
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3, 4);
            tmp += '-';
            tmp += str.substr(7);
            return tmp;
        }
    }

    const getValue = () => {
        // console.log(inputRef.value.value)
        return inputRef.value.value;
    }

    defineExpose({
        getValue
    })
</script>

<template>
    <div>
        <label>
            <p v-if="label">{{ label }}</p>
            <input ref="inputRef" type="text" v-model="model" @input="getPhoneMask" :placeholder="placeholder" :maxlength="13" :disabled="disabled">
        </label>
        <div v-if="msg" :style="{'color': msgColor || $color.labelcolor}"><small>{{ msg }}</small></div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../assets/scss/ui-components/ksa_input";

    label {
        p {
            @include font-size_xs;
            color: $gray_color;
        }
    }
    input {
        &:disabled {
            color: $black_color;
            background: $gray-thin_color;
        }
    }
</style>